module.exports = __webpack_public_path__ + "static/media/principal.78b6c621.jpeg";